import styled from "styled-components";

export const Container = styled.div`
  margin: -1px 14px 0;
  position: relative;
`;
